export const CANNED_RESPONSES_ACTIONS = {
    VIEW_CANNED_RESPONSE: "VIEW_CANNED_RESPONSE",
    EDIT_CANNED_RESPONSE: "EDIT_CANNED_RESPONSE",
    DELETE_CANNED_RESPONSE: "DELETE_CANNED_RESPONSE",
    CREATE_CANNED_RESPONSE: "CREATE_CANNED_RESPONSE"
};
